function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Logo");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "66.4536167%",
  y1: "4.54212398%",
  x2: "29.8039357%",
  y2: "89.1887703%",
  id: "lGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCA05",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCA05",
  offset: "3.01724%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBC008",
  offset: "21.86%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F1A60F",
  offset: "53.73%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E07B1B",
  offset: "94.51%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE771C",
  offset: "97.81%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "66.9065383%",
  y1: "2.05557683%",
  x2: "34.8223776%",
  y2: "88.4910962%",
  id: "lGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EC1C24",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E31C23",
  offset: "21.97%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CB1C22",
  offset: "57.79%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A61C20",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "73.5383036%",
  y1: "22.7732125%",
  x2: "32.4937543%",
  y2: "96.8617825%",
  id: "lGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00ADEE",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#049FDC",
  offset: "15.62%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0F7AAC",
  offset: "47.14%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#20405F",
  offset: "91.31%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#24344F",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "35.5639643%",
  y1: "31.3740393%",
  x2: "66.7674344%",
  y2: "71.5941076%",
  id: "lGradient-4"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808184",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#858689",
  stopOpacity: 0.8789,
  offset: "12.11%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8E9093",
  stopOpacity: 0.4877,
  offset: "51.23%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#919396",
  stopOpacity: 0,
  offset: "100%"
})));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 221,
  height: 80
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(62.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.6,
  y: 0.6,
  width: 54,
  height: 45.6
}), /*#__PURE__*/React.createElement("text", {
  id: "SupplementaryAlertingLogoText",
  className: "logoText",
  fontFamily: "SourceSansPro-Semibold, Source Sans Pro",
  fontSize: 13.2,
  fontWeight: 500,
  "line-spacing": 12,
  letterSpacing: 0.310588253,
  fill: "#5A5F65"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 19.8,
  y: 24.4
}, "SUPPLEMENTARY"), /*#__PURE__*/React.createElement("tspan", {
  x: 19.8,
  y: 36.4
}, "ALERTING SERVICE")), /*#__PURE__*/React.createElement("path", {
  id: "SupplementaryAlertingLogoStroke",
  className: "logoStroke",
  d: "M10.2,13.8 L10.2,34.0582031",
  stroke: "#5A5F65",
  strokeWidth: 1.2,
  strokeLinecap: "square"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.86857143,20.4 C7.21714286,16.56 11.0742857,11.6742857 12.1885714,10.2685714 C12.3428571,10.08 12.4457143,9.94285714 12.4971429,9.85714286 C13.4057143,8.67428571 14.7428571,6.99428571 16.1657143,5.22857143 C16.7657143,4.49142857 17.2285714,3.92571429 17.8114286,3.18857143 C18.6,2.21142857 20.3485714,0.0171428571 20.3485714,0.0171428571 L15,0.0171428571 C15,0.0171428571 11.5371429,4.01142857 7.97142857,8.81142857 C4.62857143,13.32 1.56,17.4685714 0.445714286,21.84 C0.171428571,22.9542857 0.0685714286,24.12 0.0685714286,25.32 C0.0685714286,28.44 0.977142857,31.3371429 2.52,33.7542857 C-0.308571429,29.0742857 3.37714286,22.8514286 4.86857143,20.4 Z",
  fill: "url(#lGradient-1)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.8,29.8457143 C5.09142857,28.0971429 6.06857143,25.92 7.13142857,24.1371429 C7.97142857,22.7485714 9.94285714,19.8685714 15.36,12.8571429 L15.5142857,12.6514286 C16.4057143,11.4857143 18.0342857,9.56571429 20.4,6.65142857 L20.4,6.65142857 C21.5485714,5.17714286 23.1771429,3.20571429 23.1771429,3.20571429 L17.8285714,3.20571429 C17.2457143,3.92571429 16.7828571,4.49142857 16.1828571,5.24571429 C14.76,7.01142857 13.4057143,8.69142857 12.5142857,9.87428571 C12.4628571,9.94285714 12.3428571,10.08 12.2057143,10.2857143 C11.0914286,11.7085714 7.23428571,16.5771429 4.88571429,20.4171429 C3.37714286,22.8685714 -0.308571429,29.0914286 2.53714286,33.7714286 C3.96,35.9828571 5.91428571,37.8 8.22857143,39.0171429 C5.55428571,37.5257143 4.18285714,33.5142857 4.8,29.8457143 Z",
  fill: "url(#lGradient-2)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7085714,40.6628571 C22.3371429,40.6628571 29.9485714,34.8514286 29.9485714,25.1314286 C29.9485714,24 29.8285714,22.8857143 29.5714286,21.8228571 C28.5771429,17.8971429 25.9885714,14.1428571 23.04,10.1485714 C24.3942857,8.41714286 25.8857143,6.61714286 25.8857143,6.61714286 L20.4,6.61714286 L20.4,6.61714286 L20.4,6.61714286 C18.0342857,9.53142857 16.4057143,11.4514286 15.5142857,12.6171429 L15.36,12.8228571 C9.94285714,19.8342857 7.97142857,22.7142857 7.13142857,24.1028571 C6.06857143,25.8685714 5.09142857,28.0628571 4.8,29.8114286 C4.18285714,33.48 5.55428571,37.4914286 8.21142857,38.9657143 C10.1657143,40.0285714 12.3771429,40.6285714 14.7085714,40.6628571 L14.7085714,40.6628571 L14.7085714,40.6628571 Z M8.36571429,32.1257143 C8.36571429,29.0742857 10.3885714,26.3142857 11.88,24.2571429 C13.2171429,22.4228571 14.5028571,20.8457143 14.8971429,20.3828571 C14.9657143,20.2971429 15.0171429,20.2457143 15.0171429,20.2457143 C15.0171429,20.2457143 15.48,20.7942857 16.1657143,21.6514286 C16.4914286,22.0628571 16.8685714,22.5428571 17.2628571,23.0742857 C17.5542857,23.4514286 17.8457143,23.8628571 18.1542857,24.2742857 C18.1885714,24.3257143 18.2228571,24.3771429 18.2571429,24.4285714 C21.2571429,28.4742857 21.6685714,30.2228571 21.6685714,31.8171429 C21.6685714,35.2285714 19.1314286,38.9314286 15,38.9314286 C10.6457143,38.8971429 8.36571429,35.8114286 8.36571429,32.1257143 Z",
  fill: "url(#lGradient-3)"
});

var SvgSasLogo = function SvgSasLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "221px",
    height: "80px",
    viewBox: "0 0 221 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, _ref5, _ref6, /*#__PURE__*/React.createElement("g", {
    id: "Untitled-1",
    transform: "translate(33.000000, 17.000000)",
    fillRule: "nonzero"
  }, _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("path", {
    d: "M15.0171429,20.2285714 C15.0857143,20.1428571 15.0171429,20.2285714 15.0171429,20.2285714 L15.0171429,20.2285714 L15.0171429,20.2285714 C15.0171429,20.2285714 15.48,20.7771429 16.1657143,21.6342857 C16.4914286,22.0457143 16.8685714,22.5257143 17.2628571,23.0571429 C17.5542857,23.4342857 17.8457143,23.8457143 18.1542857,24.2571429 C18.1885714,24.3085714 18.2228571,24.36 18.2571429,24.4114286 C20.3657143,27.24 21.1885714,28.9371429 21.4971429,30.2571429 L29.5714286,21.9257143 C29.5714286,21.9085714 29.5542857,21.8742857 29.5542857,21.8571429 C28.56,17.9314286 25.9714286,14.1771429 23.0228571,10.1828571 C23.0228571,10.1828571 23.0228571,10.1828571 23.0228571,10.1828571 C20.52,13.3028571 17.3828571,17.2285714 15.0171429,20.2285714 Z",
    fill: "url(#lGradient-4)",
    style: {
      mixBlendMode: "multiply"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSasLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SASLogo.fe4ed61a.svg";
export { ForwardRef as ReactComponent };